import {
  Add,
  Assignment,
  Create,
  ExpandLess,
  ExpandMore,
  Gavel,
  Group,
  Publish,
  TableRows, UploadFile,
} from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ApartmentIcon from "@mui/icons-material/Apartment";
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import FeedIcon from "@mui/icons-material/Feed";
import LinkIcon from "@mui/icons-material/Link";
import SquareFootOutlinedIcon from "@mui/icons-material/SquareFootOutlined";
import {
  Collapse,
  ListItemIcon,
  Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { StyledMenuAppBar } from "../../styled/Layout";
import { getFuncionalidadesParaPerfilUsuario } from "../perfilUsuario/PerfilUsuarioEnum";
import ListSubItemComponent from "./MenuSubItem";

const MenuAppBar = () => {
  const location = useLocation();

  const drawerOpen = useSelector((state) => state.userPreferences.drawer);
  const menusVisibles = useSelector((state) =>
    getFuncionalidadesParaPerfilUsuario(state.auth.data?.menuVisible)
  );

  const [openSiniestros, setOpenSiniestros] = useState(false);
  const [openPersonal, setOpenPersonal] = useState(false);
  const [openPrevencion, setOpenPrevencion] = useState(false);
  const [openObras, setOpenObras] = useState(false);

  const showMenuDesplegablePersonal =
    menusVisibles.CredencialArt ||
    menusVisibles.ABMNominas ||
    menusVisibles.NominaMasiva ||
    menusVisibles.CertificadoDeCobertura ||
    menusVisibles.CoberturaViajeAlExterior;

  const showMenuDesplegablePrevencion =
    menusVisibles.Establecimientos ||
    menusVisibles.RGRL ||
    menusVisibles.ImportarNTE ||
    menusVisibles.Resolucion81;

  const showMenuDesplegableObras = menusVisibles.NuevaObra || menusVisibles.GestionDeObra;

  const showMenuDesplegableSiniestralidad =
    menusVisibles.Siniestralidad || menusVisibles.NuevaDenuncia;

  // Por pedido del analista, cuando el trabajador ingresa
  // al portal, deberia ver el menú "Personal" (el unico menu
  // al que tiene acceso) desplegado por defecto. Como, a partir
  // de PDCA-401, se perdió el campo "tipoUsuario", ahora es necesario
  // hardcodearlo con los menús que tiene disponible.
  const esTrabajador =
    !menusVisibles.Empresa &&
    !menusVisibles.CuentaCorriente &&
    !menusVisibles.Reintegros &&
    !showMenuDesplegableSiniestralidad &&
    !showMenuDesplegablePrevencion &&
    !menusVisibles.ABMNominas &&
    !menusVisibles.NominaMasiva &&
    menusVisibles.CertificadoDeCobertura &&
    menusVisibles.CoberturaViajeAlExterior;

  useEffect(() => {
    if (esTrabajador) {
      setOpenPersonal(true);
    }
  }, []);

  const handleClickSiniestros = () => {
    setOpenSiniestros(!openSiniestros);
  };

  const handleClickPersonal = () => {
    setOpenPersonal(!openPersonal);
  };

  const handleClickPrevencion = () => {
    setOpenPrevencion(!openPrevencion);
  };

  const handleClickObras = () => {
    setOpenObras(!openObras);
  };

  return (
    <StyledMenuAppBar.NavBar
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <div>
        {menusVisibles.Empresa && (
          <StyledMenuAppBar.ItemComponent
            path="/"
            title="Empresa"
            id="empresa"
            icon={<StyledMenuAppBar.Icon as={AccountBalanceIcon} />}
            tooltip={!drawerOpen}
            tooltipText="Empresa"
            selected={location.pathname === "/" || location.pathname.startsWith("/empresa")}
          />
        )}

        {menusVisibles.CuentaCorriente && (
          <StyledMenuAppBar.ItemComponent
            path="/cuentaCorriente"
            title="Cuenta Corriente"
            id="cuentaCorriente"
            icon={<StyledMenuAppBar.Icon as={AccountBalanceWalletIcon} />}
            tooltip={!drawerOpen}
            tooltipText="Cuenta Corriente"
            selected={location.pathname.startsWith("/cuentaCorriente")}
          />
        )}

        {showMenuDesplegablePersonal && (
          <>
            {!drawerOpen ? (
              <Tooltip title="Personal" placement="bottom" arrow>
                <StyledMenuAppBar.NodeParent
                  onClick={handleClickPersonal}
                  id="personal"
                >
                  <ListItemIcon>
                    <StyledMenuAppBar.Icon as={Group} />
                  </ListItemIcon>
                  <StyledMenuAppBar.NodeParentText>Personal</StyledMenuAppBar.NodeParentText>
                  {openPersonal ? (
                    <StyledMenuAppBar.ExpandArrow  >
                      <ExpandLess />
                    </StyledMenuAppBar.ExpandArrow>
                  ) : (
                    <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                  )}
                </StyledMenuAppBar.NodeParent>
              </Tooltip>
            ) : (
              <StyledMenuAppBar.NodeParent
                button
                onClick={handleClickPersonal}
                id="personal"
              >
                <ListItemIcon>
                  <StyledMenuAppBar.Icon as={Group} />
                </ListItemIcon>
                <StyledMenuAppBar.NodeParentText>Personal</StyledMenuAppBar.NodeParentText>
                {openPersonal ? (
                  <StyledMenuAppBar.ExpandArrow as={ExpandLess} />

                ) : (
                  <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                )}
              </StyledMenuAppBar.NodeParent>
            )}
          </>
        )}
        <Collapse in={openPersonal} timeout="auto" unmountOnExit>
          {menusVisibles.ABMNominas && (
            <ListSubItemComponent
              path="/personal/ABMnominas"
              selected={window.location.pathname.includes(
                "/personal/ABMnominas"
              )}
              title="ABM Nóminas"
              id="personal_ABMnominas"
              icon={<StyledMenuAppBar.Icon as={Create} />}
              open={drawerOpen}
              tooltipText="ABM Nóminas"
            />
          )}

          {menusVisibles.NominaMasiva && (
            <ListSubItemComponent
              path="/personal/nominaMasiva"
              selected={window.location.pathname.includes(
                "/personal/nominaMasiva"
              )}
              title="Nómina Masiva"
              id="personal_nominaMasiva"
              open={drawerOpen}
              tooltipText="Nómina Masiva"
              icon={<StyledMenuAppBar.Icon as={UploadFile} />}
            />
          )}

          {menusVisibles.CertificadoDeCobertura && (
            <ListSubItemComponent
              path="/personal/certificadoDeCobertura"
              selected={window.location.pathname.includes(
                "/personal/certificadoDeCobertura"
              )}
              title="Certificado de Cobertura"
              id="personal_certificadoDeCobertura"
              icon={<StyledMenuAppBar.Icon as={Gavel} />}
              open={drawerOpen}
              tooltipText="Certificado de Cobertura"
            />
          )}

          {menusVisibles.CoberturaViajeAlExterior && (
            <ListSubItemComponent
              path="/personal/coberturaViajeAlExterior"
              selected={window.location.pathname.includes(
                "/personal/coberturaViajeAlExterior"
              )}
              title="Cobertura Viaje al Exterior"
              id="personal_coberturaViajeAlExterior"
              icon={<StyledMenuAppBar.Icon as={UploadFile} />}
              open={drawerOpen}
              tooltipText="Cobertura Viaje al Exterior"
            />
          )}
          {
            menusVisibles.CredencialArt && (
              <ListSubItemComponent
                path="/personal/credencialArt"
                selected={window.location.pathname.includes(
                  "/personal/credencialArt"
                )}
                title="Credencial ART"
                id="personal_credencialArt"
                icon={<StyledMenuAppBar.Icon as={ContactPageIcon} />}
                open={drawerOpen}
                tooltipText="Credencial ART"
              />
            )
          }
        </Collapse >

        {showMenuDesplegablePrevencion && (
          <>
            {!drawerOpen ? (
              <Tooltip title="Prevención" placement="bottom" arrow>
                <StyledMenuAppBar.NodeParent
                  button
                  onClick={handleClickPrevencion}
                  id="prevencion"
                >
                  <ListItemIcon>
                    <StyledMenuAppBar.Icon as={ChromeReaderModeIcon} />
                  </ListItemIcon>
                  <StyledMenuAppBar.NodeParentText>Prevención</StyledMenuAppBar.NodeParentText>
                  {openPrevencion ? (
                    <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                  ) : (
                    <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                  )}
                </StyledMenuAppBar.NodeParent>
              </Tooltip>
            ) : (
              <StyledMenuAppBar.NodeParent
                button
                onClick={handleClickPrevencion}
                id="prevencion"
              >
                <ListItemIcon>
                  <StyledMenuAppBar.Icon as={ChromeReaderModeIcon} />
                </ListItemIcon>
                <StyledMenuAppBar.NodeParentText>Prevención</StyledMenuAppBar.NodeParentText>
                {openPrevencion ? (
                  <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                ) : (
                  <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                )}
              </StyledMenuAppBar.NodeParent>
            )}
          </>
        )}
        <Collapse in={openPrevencion} timeout="auto" unmountOnExit>
          {menusVisibles.Establecimientos && (
            <ListSubItemComponent
              path="/prevencion/establecimientos"
              selected={window.location.pathname.includes(
                "/prevencion/establecimientos"
              )}
              title="Establecimientos"
              id="prevencion_establecimientos"
              icon={<StyledMenuAppBar.Icon as={ApartmentIcon} />}
              open={drawerOpen}
              tooltipText="Establecimientos"
            />
          )}

          {menusVisibles.RGRL && (
            <ListSubItemComponent
              path="/prevencion/RGRL"
              selected={window.location.pathname.includes("/prevencion/RGRL")}
              title="RGRL"
              id="prevencion_establecimientos"
              icon={<StyledMenuAppBar.Icon as={FeedIcon} />}
              open={drawerOpen}
              tooltipText="RGRL"
            />
          )}

          {menusVisibles.ImportarNTE && (
            <ListSubItemComponent
              path="/prevencion/NTE"
              selected={window.location.pathname.includes("/prevencion/NTE")}
              title="Importar NTE"
              id="importar_NTE"
              icon={<StyledMenuAppBar.Icon as={Publish} />}
              open={drawerOpen}
              tooltipText="Importar NTE"
            />
          )}

          {menusVisibles.Resolucion81 && (
            <ListSubItemComponent
              path="/prevencion/resolucion-81"
              selected={window.location.pathname.includes(
                "/prevencion/resolucion-81"
              )}
              title="Resolución 81"
              id="prevencion_resolucion81"
              icon={<StyledMenuAppBar.Icon as={LinkIcon} />}
              open={drawerOpen}
              tooltipText="Resolución 81"
            />
          )}
        </Collapse>

        {
          showMenuDesplegableObras && (
            <>
              {!drawerOpen ? (
                <Tooltip title="Módulo de Obras" placement="bottom" arrow>
                  <StyledMenuAppBar.NodeParent
                    button
                    onClick={handleClickObras}
                    id="modulo_de_obras"
                  >
                    <ListItemIcon>
                      <StyledMenuAppBar.Icon as={ConstructionOutlinedIcon} />
                    </ListItemIcon>
                    <StyledMenuAppBar.NodeParentText>Módulo de Obras</StyledMenuAppBar.NodeParentText>
                    {openObras ? (
                      <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                    ) : (
                      <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                    )}
                  </StyledMenuAppBar.NodeParent>
                </Tooltip>
              ) : (
                <StyledMenuAppBar.NodeParent
                  button
                  onClick={handleClickObras}

                  id="modulo_de_obras"
                >
                  <ListItemIcon>
                    <StyledMenuAppBar.Icon as={ConstructionOutlinedIcon} />
                  </ListItemIcon>
                  <StyledMenuAppBar.NodeParentText>Módulo de Obras</StyledMenuAppBar.NodeParentText>
                  {openObras ? (
                    <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                  ) : (
                    <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                  )}
                </StyledMenuAppBar.NodeParent>
              )}
            </>
          )
        }
        <Collapse in={openObras} timeout="auto" unmountOnExit>
          {menusVisibles.GestionDeObra && (
            <ListSubItemComponent
              path="/obras/gestionDeObra"
              selected={window.location.pathname.includes("/obras/gestionDeObra")}
              title="Gestión de Obra"
              id="nueva_obra"
              icon={<StyledMenuAppBar.Icon as={EngineeringRoundedIcon} />}
              open={drawerOpen}
              tooltipText="Gestión de Obra"
            />
          )}
          {menusVisibles.NuevaObra && (
            <ListSubItemComponent
              path="/obras/nuevaObra"
              selected={window.location.pathname.includes("/obras/nuevaObra")}
              title="Nueva Obra"
              id="nueva_obra"
              icon={<StyledMenuAppBar.Icon as={SquareFootOutlinedIcon} />}
              open={drawerOpen}
              tooltipText="Nueva Obra"
            />
          )}


        </Collapse>

        {
          showMenuDesplegableSiniestralidad && (
            <>
              {!drawerOpen ? (
                <Tooltip title="Siniestros" placement="bottom" arrow>
                  <StyledMenuAppBar.NodeParent
                    button
                    onClick={handleClickSiniestros}
                    id="accidents"
                  >
                    <ListItemIcon>
                      <StyledMenuAppBar.Icon as={Assignment} />
                    </ListItemIcon>
                    <StyledMenuAppBar.NodeParentText>Siniestros</StyledMenuAppBar.NodeParentText>
                    {openSiniestros ? (
                      <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                    ) : (
                      <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                    )}
                  </StyledMenuAppBar.NodeParent>
                </Tooltip>
              ) : (
                <StyledMenuAppBar.NodeParent
                  button
                  onClick={handleClickSiniestros}
                  id="accidents"
                >
                  <ListItemIcon>
                    <StyledMenuAppBar.Icon as={Assignment} />
                  </ListItemIcon>
                  <StyledMenuAppBar.NodeParentText>Siniestros</StyledMenuAppBar.NodeParentText>
                  {openSiniestros ? (
                    <StyledMenuAppBar.ExpandArrow as={ExpandLess} />
                  ) : (
                    <StyledMenuAppBar.ExpandArrow as={ExpandMore} />
                  )}
                </StyledMenuAppBar.NodeParent>
              )}
            </>
          )
        }
        <Collapse in={openSiniestros} timeout="auto" unmountOnExit>
          {menusVisibles.Siniestralidad && (
            <ListSubItemComponent
              path="/siniestros/siniestralidad"
              selected={location.pathname === "/siniestros/siniestralidad"}
              title="Siniestralidad"
              id="siniestros_siniestralidad"
              icon={<StyledMenuAppBar.Icon as={TableRows} />}
              open={drawerOpen}
              tooltipText="Siniestralidad"
            />
          )}

          {menusVisibles.NuevaDenuncia && (
            <ListSubItemComponent
              path="/siniestros/nuevaDenuncia"
              selected={location.pathname === "/siniestros/nuevaDenuncia"}
              title="Nueva Denuncia"
              id="siniestros_nuevaDenuncia"
              icon={<StyledMenuAppBar.Icon as={Add} />}
              open={drawerOpen}
              tooltipText="Nueva Denuncia"
            />
          )}
        </Collapse>

        {
          menusVisibles.ExamenesMedicosPeriodicos && (
            <StyledMenuAppBar.ItemComponent
              path="/examenesPeriodicos"
              title="Exámenes Periódicos"
              id="examenesPeriodicos"
              icon={<StyledMenuAppBar.Icon as={ContactPageIcon} />}
              tooltip={!drawerOpen}
              tooltipText="Examenés Periódicos"
              selected={location.pathname.startsWith("/examenesPeriodicos")}
            />
          )
        }

        {
          menusVisibles.Reintegros && (
            <StyledMenuAppBar.ItemComponent
              path="/reintegros"
              title="Reintegros de Gastos"
              id="reintegros"
              icon={<StyledMenuAppBar.Icon as={CurrencyExchangeIcon} />}
              tooltip={!drawerOpen}
              tooltipText="Reintegros de Gastos"
              selected={location.pathname.startsWith("/reintegros")}
            />
          )
        }
      </div >
    </StyledMenuAppBar.NavBar >
  );
};

export default MenuAppBar;
